export enum RoomStages {
  NEW = 1,
  IN_PROGRESS = 2,
  IN_DISPUTE = 3,
  WAIT_FOR_REVIEW = 4,
  ARCHIVED = 5,
  REVIEWED = 6,
}
